import { createStore } from "@rasenganjs/signals";
import chats from "./signals/chats";

export default createStore([chats]);